declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void
      execute: (siteKey: string, options: { action: string }) => Promise<string>
    }
  }
}

export function useRecaptcha() {
  const siteKey = import.meta.env.VITE_RECAPTCHA_KEY

  if (import.meta.env.DEV && !siteKey) {
    console.warn(
      '[useRecaptcha] VITE_RECAPTCHA_KEY is empty — execute() will resolve with empty token in dev. Add the key to .env.local for production-like behavior.',
    )
  }

  function loadScript(): Promise<void> {
    return new Promise((resolve) => {
      if (document.querySelector('script[src*="recaptcha"]')) {
        resolve()
        return
      }
      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
      script.async = true
      script.defer = true
      script.onload = () => resolve()
      document.head.appendChild(script)
    })
  }

  async function execute(action: string): Promise<string> {
    if (!siteKey) return ''
    await loadScript()
    return new Promise((resolve) => {
      if (!window.grecaptcha) {
        resolve('')
        return
      }
      window.grecaptcha.ready(() => {
        window.grecaptcha?.execute(siteKey, { action }).then(resolve)
      })
    })
  }

  return { execute }
}
